export default __webpack_public_path__ + "static/media/640_store03-en-web.995c4fe7.png";